import apiClient from '@/services/axios'
import config from '@/configs'

// [Projects]*****************************
// get all projects
export async function fetchProjects() {
  return apiClient
    .get(config.api.pm.projects)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// get projects by query
export async function fetchProjectsByQuery(query) {
  return apiClient
    .post(`${config.api.pm.projects}/query`, query)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// get a project by id
export async function fetchProjectById(id) {
  return apiClient
    .get(`${config.api.pm.projects}/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// get projects by customer id
export async function fetchProjectsByCustomerId(id) {
  return apiClient
    .get(`${config.api.pm.projects}/customer/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Customers API]:', err))
}

// create a new project
export async function createProject(project) {
  return apiClient
    .post(config.api.pm.projects, project)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// update a project
export async function updateProject(project) {
  return apiClient
    .put(config.api.pm.projects, project)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}
// [Contract]*****************************

// get contracts by query
export async function fetchContractsByQuery(query) {
  return apiClient
    .post(`${config.api.pm.contracts}/query`, query)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// get customer contracts by customer id
export async function fetchContracts(id) {
  return apiClient
    .get(`${config.api.pm.projects}/${id}/contracts`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// insert the contract by customer id
export async function insertContract(id, contract) {
  return apiClient
    .post(`${config.api.pm.projects}/${id}/contracts`, contract)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// [History]*****************************
// get customer histories by customer id
export async function fetchHistory(id) {
  return apiClient
    .get(`${config.api.pm.projects}/${id}/history`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// insert the history by customer id
export async function insertHistory(id, content) {
  return apiClient
    .post(`${config.api.pm.projects}/${id}/history`, {
      type: 'user_record',
      content: content,
    })
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Projects API]:', err))
}

// [Task]*****************************
// update a project task
export async function updateTask(task) {
  return apiClient
    .put(config.api.pm.tasks, task)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Tasks API]:', err))
}
